/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { m, mb } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import { styledButton } from '@styles/buttons';

const { colors } = theme;

export const StyledUploadWrapper = styled.div`
  width: 80%;
  align-self: center;
  border: 1px solid ${colors.translucentDarkBlue};
  border-style: dashed;
  background-color: ${props => (props.treatmentFormName ? colors.white : colors.lightGray)};
  box-shadow: 0 5px 3px 0px ${colors.transluscentDark};
  cursor: pointer;

  ${mb(4)}
  button {
    display: none;
  }
  > div {
    ${m(3)}
  }
`;

export const StyledButtonSubmit = styled.button`
  ${styledButton}
  font-weight: bold;
  border-radius: 10px;
  width: ${props => (props.opinionFlow ? 'auto' : props.isModal || props.treatmentFormName ? '130px' : '150px')};
  align-self: center;
  background-color: ${props => (props.TreatmentCostFlow ? '#3EC6E3' : props.treatmentFormName ? colors.white : colors.newThemeDarkBlue)};
  color: ${props => (props.TreatmentCostFlow ? 'white' : props.treatmentFormName ? colors.newThemeDarkBlue : colors.white)};
  border: none;
  outline: none;
  padding: ${props => (props.treatmentFormName || props.isModal) && '10px'};
`;

export const StyledShowDocumentsWrapper = styled.div`
  width: 90%;
  align-self: center;
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: flex-start;
  padding: 5px;
  margin-bottom: 32px;

  ${breakpoint('mobile', 'tablet')`
    justify-content: center; 
  `}

  ${breakpoint('desktop')`
    ${props =>
    props.isModal
      && `flex-wrap: unset;
       row-gap: unset;
       overflow-x: overlay;
       overflow-y : hidden;
       height: 50px;
       margin-bottom: 10px;
       
       ::-webkit-scrollbar {
          height: 5px;
       }

       ::-webkit-scrollbar-track {
          background: ${colors.lightGray}; 
          border-radius: 10px;
       }
 

       ::-webkit-scrollbar-thumb {
          background: ${colors.translucentDarkBlue}; 
          border-radius: 10px;
       }

    `}
  `}
`;

export const StyledFileWrapper = styled.div`
  width: ${props => (props.isModal ? '150px' : '200px')};
  height: ${props => (props.isModal ? '25px' : '40px')};
  border-radius: 8px;
  background-color: ${colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-left: 10px;
  border: 1px solid ${colors.translucentDarkBlue};
  padding: 5px;
  cursor: pointer;
`;

export const StyledFileNameWrapper = styled.div`
  width: 120px;
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${colors.navyGray};

  ${breakpoint('desktop')`
    ${props => props.isModal && 'width: 80px'};
  `}
`;

export const StyledIconWrapper = styled.div`
  width: 20px;
  svg {
    width: 100%;
  }
`;
